import React from 'react'
//TODO: BEGIN - Fix circular dependencies
import { useUnsafeMoteLoopContext } from 'web/src/screens/MoteLanding/MoteLoopProvider'
//TODO: END
import { preventBubblingEvent } from '@mote/helpers/browser'
import { KeyboardKey } from '@mote/helpers/constants'
import { Block, Button, H3 } from '@mote/ui'
import styled, { css, th } from '@xstyled/styled-components'
import { CloseButton } from '../../../shared/components'
import { useMotePlayer } from '../../../shared/contexts/motePlayer.context'
import { MoteCardRichEmojiPicker } from '../MoteCardRichEmojiPicker'
import { moteCardFluidDimensionsAdjuster } from '../fluidSizing'

export function MoteCardEndState({
  shouldEnableReactions,
  toggleInitialState
}) {
  const { replay, playerDimensions } = useMotePlayer()
  const unsafeMoteLoopContext = useUnsafeMoteLoopContext()

  return (
    <Root>
      <StyledCloseButton
        size={moteCardFluidDimensionsAdjuster(36, 32, playerDimensions?.width)}
        onClick={toggleInitialState}
      />
      {shouldEnableReactions && !unsafeMoteLoopContext?.getIsLoopy() ? (
        <Block align='center'>
          <H3
            fontSize={moteCardFluidDimensionsAdjuster(
              18,
              12,
              playerDimensions?.width
            )}
            lineHeight='140%'
            color='white'
          >
            Quick react
          </H3>

          <MoteCardRichEmojiPicker />
        </Block>
      ) : null}
      <Block
        margin={`${moteCardFluidDimensionsAdjuster(
          unsafeMoteLoopContext?.getIsLoopy() ? 20 : 28,
          unsafeMoteLoopContext?.getIsLoopy() ? 8 : 12,
          playerDimensions?.width
        )}px 0 0 0`}
        gap={moteCardFluidDimensionsAdjuster(8, 8, playerDimensions?.width)}
        spreadX
        maxWidth={moteCardFluidDimensionsAdjuster(
          182,
          182,
          playerDimensions?.width
        )}
      >
        <ReplayButton
          ref={btn => btn?.focus()}
          aria-label='Replay'
          text='Play again'
          variant={'primary'}
          onClick={event => {
            preventBubblingEvent(event)
            replay()
          }}
          onKeyDown={event => {
            switch (event.keyCode) {
              case KeyboardKey.Space:
              case KeyboardKey.Enter:
                preventBubblingEvent(event)
                replay()
                break
            }
          }}
          height={moteCardFluidDimensionsAdjuster(
            40,
            unsafeMoteLoopContext?.getIsLoopy() ? 32 : 40,
            playerDimensions?.width
          )}
          fontSize={moteCardFluidDimensionsAdjuster(
            15,
            unsafeMoteLoopContext?.getIsLoopy() ? 12 : 15,
            playerDimensions?.width
          )}
          block
        />
      </Block>
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: ${th.color('blackAlpha.500')};
  border-radius: 8px;
`

const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  top: 3.5%;
  right: 3.5%;
  color: white;

  svg {
    height: 24px;
    width: 24px;
  }

  &:hover,
  &:focus {
    color: white;
    background: ${th.color('whiteAlpha.300')};
  }

  &:focus {
    box-shadow: outline;
  }
`

const ReplayButton = styled(Button)`
  &:focus {
    box-shadow: outline;
  }

  height: ${({ height }) => height}px;

  ${({ fontSize }) => css`
    span.button-text {
      font-size: ${fontSize}px;
    }
  `}
`
